import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Button from "../../components/Button";
import { textField } from "../../components/Form";
import * as Yup from "yup";
import { Formik, Field } from "formik";
import AuthenticationAPI from "../../api/AuthenticationAPI";
import ErrorHandler from "../../helpers/ErrorHandler";
import Alert from "@material-ui/lab/Alert";
import Separator from "../../components/Separator";

const ChangePasswordModal = ({ open, onHide, forceSetPassword }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [showError, setShowError] = useState("");
    const [showSuccess, setShowSuccess] = useState("");

    const ChangePasswordValidation = Yup.object({
        password: Yup.string().required("Password is required"),
        newPassword:
            !forceSetPassword &&
            Yup.string().required("New Password is required"),
        confirmationPassword: Yup.string().oneOf(
            [Yup.ref("password"), null],
            "Passwords must match"
        )
    });

    const handleChangePassword = values => {
        setIsLoading(true);

        const updatePasswordAPI = forceSetPassword
            ? AuthenticationAPI.setPassword(values)
            : AuthenticationAPI.changePassword(values);

        updatePasswordAPI
            .then(() => {
                setShowError("");
                let setPasswordMsg =
                    "Password has been set successfully. Please re-login using your new password";
                let changePasswordMsg =
                    "Password has been changed successfully. Please re-login using your new password";
                setShowSuccess(
                    `Password ${
                        forceSetPassword ? setPasswordMsg : changePasswordMsg
                    } Success`
                );

                setTimeout(() => {
                    onHide();
                    localStorage.removeItem("access_token");
                    window.location = `/login`;
                }, 5000);
            })
            .catch(err => {
                setIsLoading(false);
                setShowSuccess("");

                let error = ErrorHandler(err);
                setShowError(error.message);
            })
            .finally(() => {
                onHide();
            });
    };

    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={"sm"}
                open={open}
                onClose={onHide}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    Change Password
                </DialogTitle>
                <DialogContent>
                    {showError && <Alert severity="error">{showError}</Alert>}
                    {showSuccess && (
                        <Alert severity="error">{showSuccess}</Alert>
                    )}
                    <Formik
                        initialValues={{
                            password: "",
                            newPassword: "",
                            confirmationPassword: ""
                        }}
                        validationSchema={ChangePasswordValidation}
                        onSubmit={values => handleChangePassword(values)}
                    >
                        {props => (
                            <>
                                <div>
                                    <Field
                                        type="password"
                                        name="password"
                                        placeholder="Password"
                                        disabled={isLoading}
                                        component={textField}
                                    />
                                </div>
                                <Separator variant="vertical" />
                                {forceSetPassword ? null : (
                                    <>
                                        <div>
                                            <Field
                                                type="password"
                                                name="newPassword"
                                                placeholder="New Password"
                                                disabled={isLoading}
                                                component={textField}
                                            />
                                        </div>
                                        <Separator variant="vertical" />
                                    </>
                                )}

                                <div>
                                    <Field
                                        type="password"
                                        name="confirmationPassword"
                                        placeholder="Confirmation Password"
                                        disabled={isLoading}
                                        component={textField}
                                    />
                                </div>
                                <Separator variant="vertical" size={40} />
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "flex-end"
                                    }}
                                >
                                    <div>
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            disabled={isLoading}
                                            style={{
                                                fontSize: "15px",
                                                lineHeight: "1.2",
                                                fontFamily: "Poppins",
                                                height: "40px",
                                                padding: "0 20px",
                                                marginRight: "12px"
                                            }}
                                            onClick={onHide}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                    <div>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            disabled={isLoading}
                                            style={{
                                                color: "#fff",
                                                fontSize: "15px",
                                                lineHeight: "1.2",
                                                fontFamily: "Poppins",
                                                height: "40px",
                                                padding: "0 20px"
                                            }}
                                            onClick={props.handleSubmit}
                                        >
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default ChangePasswordModal;
